import { render, staticRenderFns } from "./CustDeliveryReplyList.vue?vue&type=template&id=53dd9d66&scoped=true"
import script from "./CustDeliveryReplyList.vue?vue&type=script&lang=js"
export * from "./CustDeliveryReplyList.vue?vue&type=script&lang=js"
import style0 from "./CustDeliveryReplyList.vue?vue&type=style&index=0&id=53dd9d66&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53dd9d66",
  null
  
)

export default component.exports